module.exports = __webpack_public_path__ + "assets/images/JL-logo-small.png";